module.exports = __webpack_public_path__ + "static/media/mui-templates.a3529e36.jpg";